import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceResultForm from './ServiceResultForm'
import { storeServiceResult } from '../services'

import { handleError } from '../../../helpers'

export default function NewServiceResultModal({ visible, onClose, serviceReport }) {
	const [loading, setLoading] = useState(false)
	const history = useHistory()
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: {
			result_format_id: serviceReport.result_format_id,
			service_report_id: serviceReport.id
		}
	})

	const onSubmit = values => {
		setLoading(true)
		storeServiceResult(values)	
			.then(res => {
				message.success(res.data.message)
				history.push(`/service_results/${res.data.data.id}`)
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Crear Informe de Servicio</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ServiceResultForm 
						register={register}
						errors={errors}
					/>
					<Button color="primary" type="submit" disabled={loading}>
						{ loading && <Spinner animation='border' size="sm" /> }
						Crear Informe de Servicio
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}